
































import Vue from 'vue'
import SimpleModalLayout from '@/components/modal/basics/SimpleModal/SimpleModalLayout.vue'
import { AreaId } from '@/core/Facilities'

export default Vue.extend({
  components: {
    SimpleModalLayout,
  },
  props: {
    areaIds: {
      type: Array as () => AreaId[],
      default: [],
    },
  },
  methods: {
    handleNavigate() {
      this.$router.push({
        path: '/facilities',
        query: { areaIds: this.areaIds.map((id) => `${id}`) },
      })
      this.$modal.pop()
    },
  },
})
